<template lang="pug">
  v-container.pa-0(fluid)
    v-row
      v-col(cols="12")
        .d-flex
          v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
          p.subtitle-1.py-1.pr-1.mb-0 {{ title }}
          v-btn.ml-4(@click="addItem()" icon)
            v-icon(size="24" color="green lighten-1") mdi-plus-circle
    v-row
      v-col.pa-0(cols="12" sm="6" v-for="(name, ind) in names", :key="'name'+ind")
        .d-flex
          LobbyTextField(:countryItems="countryItems", :value="name" @input="(name_ev)=>{updateItem(ind, name_ev)}", :labelName="labelName")
          v-btn(v-if="ind != 0" @click="removeItem(ind)" icon)
            v-icon(size="24" color="red lighten-1") mdi-close-circle
</template>

<script>

  import { lobbyCountries } from "@/store/variablesGlobals";
  import LobbyTextField from "./LobbyTextField";

  export default {
    name: "LobbyGames",
    components: {
      LobbyTextField,
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      clearForm: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '',
      },
      labelName: {
        type: String,
        default: '',
      },

    },
    data:() =>({
      names: [{country: 'ES', text: ''}],
      namesLength: '1',
      countryItems: lobbyCountries,
    }),
    watch: {
      value: function(val){
        this.names = val;
      },
      clearForm: function(val){
        if (val){
          if(this.value.length > 0){
            this.setFields();
          } else {
            this.clearFields();
          }
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      addItem(){
        this.names.push({country: 'ES', text: ''});
        this.namesLength = (parseInt(this.namesLength)+1).toString();
        this.sendValue();
      },
      removeItem(ind){
        if(parseInt(this.namesLength) > 1){
          this.names.splice(ind, 1);
          this.namesLength = (parseInt(this.namesLength)-1).toString();
          this.sendValue();
        }
      },
      updateItem(ind, name){
        this.names[ind] = {country: name.country, text: name.text};
        this.triggerReactivityTrap();
        this.sendValue();
      },
      sendValue(){
        this.$emit('input', this.names);
      },
      clearFields(){
        this.names = [{country: 'ES', text: ''}];
        this.namesLength = '1';
      },
      setFields(){
        this.names = this.value;
        this.namesLength = this.value.length.toString();
      },
      triggerReactivityTrap(){
        //triggering the reactivity
        this.names.push('');
        this.names.pop();
      },
    },
  }
</script>

<style lang="sass">
</style>